import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultQuery: '=',
        filter: '=',
        trainers: '=',
        sites: '<'
    },
    template: `
        <form ng-submit="vm.applyFilter()" class="table-filters">
            <div class="form form-filter">
                <div class="fields">
                    <div class="row">
                        <label class="label">{{ 'filter.Course' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.course" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row row-md row-separated row-flex02">
                        <label class="label">{{ 'filter.Employee' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.userId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find an employee')"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'planning.Trainers' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.trainers.options"
                                    selected-model="vm.multiFilter.trainers.model"
                                    extra-settings="vm.multiFilter.trainers.settings"
                                    translation-texts="vm.filterTranslations"
                                    events="vm.multiFilter.trainers.events"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.formAccessSites.options"
                                    selected-model="vm.multiFilter.formAccessSites.model"
                                    extra-settings="vm.multiFilter.formAccessSites.settings"
                                    translation-texts="vm.filterTranslations"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Status' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.statuses.options"
                                selected-model="vm.multiFilter.statuses.model"
                                extra-settings="vm.multiFilter.statuses.settings"
                                translation-texts="vm.filterTranslations">
                            </div>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'general.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($translate, lodash, SiteService, FilterService, UserResource, ROLE_CODE_ENUM, COURSE_PROGRESS_STATUS_TYPE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.SiteService = SiteService;
        this.FilterService = FilterService;
        this.UserResource = UserResource;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
    }

    $onInit () {
        this.filter.errors = {};
        this.initMultiFilter();
        this.filterTranslations = this.FilterService.getTranslations();
        this.applyFilter();
    }

    initMultiFilter () {
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });

        const statusOptions = [
            { value: 'IN_VALIDATION', label: this.$translate.instant('validations.In validation') },
            { value: 'COMPLETED', label: this.$translate.instant('validations.Completed') }
        ];
        const statusOptionsSelected = [statusOptions[0]];

        const trainersSettings = {
            checkBoxes: true,
            showCheckAll: true,
            showUncheckAll: true,
            enableSearch: true,
            smartButtonMaxItems: 2,
            selectionLimit: 0
        };

        this.noTrainerOption = {
            value: null,
            label: this.$translate.instant('validations.No trainer')
        };

        const trainersOptions = this.trainers.map((val) => ({
            value: val.id,
            label: val.displayName
        }));

        const selectedTrainersOptions = this.lodash.clone(trainersOptions);

        trainersOptions.unshift(this.noTrainerOption);

        this.multiFilter = {
            formAccessSites: {
                model: this.lodash.clone(siteOptions),
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            trainers: {
                model: selectedTrainersOptions,
                options: trainersOptions,
                settings: trainersSettings,
                events: {
                    onItemDeselect: this.getTrainerItemCallback(),
                    onItemSelect: this.getTrainerItemCallback(),
                    onSelectAll: this.selectAllCallback(trainersOptions)
                }
            },
            statuses: {
                model: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    selectAllCallback (trainersOptions) {
        return () => {
            const { multiFilter } = this;
            multiFilter.trainers.model = trainersOptions.filter(model => model.value !== null);
        };
    }

    getTrainerItemCallback () {
        return item => {
            const { multiFilter } = this;
            // if all sites option, set only it, otherwise deselect all sites if checkbox is selected
            if (item.value === null) {
                multiFilter.trainers.model = [this.noTrainerOption];
            }
            else {
                multiFilter.trainers.model = multiFilter.trainers.model.filter(model => model.value !== null);
            }
        };
    }

    applyFilter () {
        const formAccessSiteIds = !this.multiFilter.formAccessSites.model.length ? [-1] : this.multiFilter.formAccessSites.model.map(site => site.value);
        const statuses = !this.multiFilter.statuses.model.length ? [] : this.multiFilter.statuses.model.map(status => status.value);
        const trainers = !this.multiFilter.trainers.model.length ? [] : this.multiFilter.trainers.model.map(trainer => trainer.value);
        this.filter = this.lodash.assign(this.filter, { formAccessSiteIds });
        this.filter = this.lodash.assign(this.filter, { statuses });
        this.filter = this.lodash.assign(this.filter, { trainers });

        this.filter.errors = {};
        this.list.fetch(this.defaultQuery, this.filter);
    }

    resetFilter () {
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
        this.selectedEmployee = null;
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            name: input,
            pageSize: 0
        };
        const siteIds = this.multiFilter.formAccessSites.model.map(site => site.value);
        if (siteIds) {
            params.siteIds = siteIds;
        }
        return this.UserResource.getUsers({}, params).$promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/validations/filter/index.js